module.exports = __webpack_public_path__ + "static/media/VidhyaOnline new.fc0f251c.png";